import { render, staticRenderFns } from "./CompensationProcedureTree.vue?vue&type=template&id=24801578"
import script from "./CompensationProcedureTree.vue?vue&type=script&lang=js"
export * from "./CompensationProcedureTree.vue?vue&type=script&lang=js"
import style0 from "./CompensationProcedureTree.vue?vue&type=style&index=0&id=24801578&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports